(function () {
  function init() {
    var rows = Array.prototype.slice.call(document.querySelectorAll('.sbc-collection'));
    if (!rows.length) return;

    var activeCollections = [];

    function applyRowVisibility() {
      rows.forEach(function (row) {
        var handle = row.getAttribute('data-collection');
        var collectionOk = activeCollections.length === 0 || activeCollections.indexOf(handle) !== -1;

        var groups = row.querySelectorAll('.collection-grid-inner');
        var anyGroupVisible = groups.length === 0;
        groups.forEach(function (group) {
          if (group.dataset.mixerVisible !== '0') anyGroupVisible = true;
        });

        row.style.display = (collectionOk && anyGroupVisible) ? '' : 'none';
      });
    }

    document.querySelectorAll('.js-row-filter-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.getAttribute('data-collection-toggle');
        var idx = activeCollections.indexOf(handle);
        if (idx === -1) {
          activeCollections.push(handle);
          btn.classList.add('mixitup-control-active');
        } else {
          activeCollections.splice(idx, 1);
          btn.classList.remove('mixitup-control-active');
        }
        applyRowVisibility();
      });
    });

    // /collections#harvest (from a retired stand-alone collection link) opens
    // the hub with that collection pre-selected in the sidebar
    var hash = (window.location.hash || '').replace('#', '');
    if (hash) {
      var preset = document.querySelector('.js-row-filter-toggle[data-collection-toggle="' + hash + '"]');
      if (preset) preset.click();
    }

    if (typeof mixitup === 'undefined') {
      applyRowVisibility();
      return;
    }

    rows.forEach(function (row) {
      row.querySelectorAll('.js-sbc-grid').forEach(function (target) {
        var group = target.closest('.collection-grid-inner');
        if (group) group.dataset.mixerVisible = '1';

        try { mixitup(target, {
          selectors: { target: '.grid__item' },
          animation: { enable: false },
          multifilter: { enable: true },
          // MixItUp 3 accepts 'local' | 'global'; 'page' threw "Invalid value for controls.scope"
          // on the first grid, which aborted init and left every Fragrance/Size button dead.
          controls: { scope: 'global' },
          callbacks: {
            onMixEnd: function (state) {
              if (group) {
                group.dataset.mixerVisible = state.totalShow > 0 ? '1' : '0';
                group.style.display = state.totalShow > 0 ? '' : 'none';
              }
              applyRowVisibility();
            }
          }
        }); } catch (err) { if (window.console) console.error('[hub filters]', err); }
      });
    });

    applyRowVisibility();

    // ---- filter state: summary + clear all, and ?c=&f=&s= in the URL so back /
    //      reload / shared links keep the selection ----
    var summary = document.querySelector('.js-active-filters');
    var summaryCount = document.querySelector('.js-active-count');
    var clearBtn = document.querySelector('.js-clear-filters');

    function activeButtons() {
      return {
        c: Array.prototype.slice.call(document.querySelectorAll('.js-row-filter-toggle.mixitup-control-active')),
        f: Array.prototype.slice.call(document.querySelectorAll('[data-filter-group="family"] button.mixitup-control-active')),
        s: Array.prototype.slice.call(document.querySelectorAll('[data-filter-group="size"] button.mixitup-control-active'))
      };
    }
    function key(btn) {
      var t = btn.getAttribute('data-toggle') || ('.' + btn.getAttribute('data-collection-toggle'));
      return t.replace(/^\.(family-|size-)?/, '');
    }
    function groupActive(group) {
      return Array.prototype.slice.call(group.querySelectorAll('.shop-filters__options button.mixitup-control-active'));
    }
    function syncGroup(group) {
      var n = groupActive(group).length;
      var h = group.querySelector('.js-shop-filter-trigger h4');
      if (h) {
        var badge = h.querySelector('.js-group-count');
        if (!badge) { badge = document.createElement('span'); badge.className = 'js-group-count'; h.appendChild(badge); }
        badge.textContent = n ? '(' + n + ')' : '';
      }
      var clear = group.querySelector('.js-group-clear');
      if (clear) clear.disabled = n === 0;
    }
    function syncState() {
      var a = activeButtons();
      var total = a.c.length + a.f.length + a.s.length;
      if (summary) summary.hidden = total === 0;
      if (summaryCount) summaryCount.textContent = total + (total === 1 ? ' filter' : ' filters');
      document.querySelectorAll('.shop-filters__group').forEach(syncGroup);
      var qs = [];
      if (a.c.length) qs.push('c=' + a.c.map(key).join(','));
      if (a.f.length) qs.push('f=' + a.f.map(key).join(','));
      if (a.s.length) qs.push('s=' + a.s.map(key).join(','));
      var url = window.location.pathname + (qs.length ? '?' + qs.join('&') : '');
      if (window.history && window.history.replaceState) window.history.replaceState(null, '', url);
    }
    // capture phase: MixItUp stops propagation on its control buttons, so a
    // bubbling listener never hears Fragrance/Size clicks
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.js-row-filter-toggle, .shop-filters button[data-toggle]')) { setTimeout(syncState, 50); }
    }, true);
    document.querySelectorAll('.js-group-clear').forEach(function (btn) {
      btn.addEventListener('click', function () {
        groupActive(btn.closest('.shop-filters__group')).forEach(function (b) { b.click(); });
        syncState(); setTimeout(syncState, 80);
      });
    });
    if (clearBtn) clearBtn.addEventListener('click', function () {
      var a = activeButtons();
      a.c.concat(a.f, a.s).forEach(function (btn) { btn.click(); });
      syncState(); setTimeout(syncState, 80);
    });

    // restore from URL (the mixers above are created synchronously, so this is safe to run now)
    (function () {
      var params = new URLSearchParams(window.location.search);
      (params.get('c') || '').split(',').filter(Boolean).forEach(function (h) {
        var b = document.querySelector('.js-row-filter-toggle[data-collection-toggle="' + h + '"]');
        if (b && !b.classList.contains('mixitup-control-active')) b.click();
      });
      (params.get('f') || '').split(',').filter(Boolean).forEach(function (h) {
        var b = document.querySelector('[data-filter-group="family"] button[data-toggle=".family-' + h + '"]');
        if (b && !b.classList.contains('mixitup-control-active')) b.click();
      });
      (params.get('s') || '').split(',').filter(Boolean).forEach(function (h) {
        var b = document.querySelector('[data-filter-group="size"] button[data-toggle=".size-' + h + '"]');
        if (b && !b.classList.contains('mixitup-control-active')) b.click();
      });
      syncState();
    })();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
